// extracted by mini-css-extract-plugin
export default {"cart_counter_block":"style_cart_counter_block__OjPpx","counterBtn":"style_counterBtn__86sGO"};